import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from 'jquery';

class UsedTeamsContainer extends Component {
    componentDidMount() {
        $('body').scrollTop(0);
    }

    countTeams(lineups) {
        if (isEmpty(lineups)) {
            return 0;
        }
        let teamUsed = {};
        Object.keys(lineups).map((key) => {
            let lineup = lineups[key];

            for (let i in lineup.players) {
                let unit = lineup.players[i];
                let teamName = unit.team;

                if (teamUsed[teamName] === true) {
                    continue;
                }

                if (!teamUsed.hasOwnProperty(teamName)) {
                    teamUsed[teamName] = true;
                }
            }
        });
        return !isEmpty(teamUsed) ? Object.keys(teamUsed).length : 0;
    }

    render() {
        const {lineups} = this.props;
        const lineupsList = lineups.all();
        const teamsCount = this.countTeams(lineupsList);
        const lineupsCount = !isEmpty(lineupsList) ? Object.keys(lineupsList).length : 0;

        return (
            <div className="tab-content teams-content">
                <div className="lineups-info-holder">
                    <ul className="lineups-info">
                        <li>
                            <strong>{teamsCount}</strong> Teams Used
                        </li>
                        <li>
                            <strong>{lineupsCount}</strong> Lineups
                        </li>
                    </ul>
                </div>
                {this.props.children}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {lineups} = state.lineupsData;

    return {
        lineups,
    };
}

export default connect(mapStatesToProps)(UsedTeamsContainer);
